export class PutDataCatalogExternalContextDocumentRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "content",
            "baseName": "content",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceRef",
            "baseName": "sourceRef",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PutDataCatalogExternalContextDocumentRequest.attributeTypeMap;
    }
    constructor() {
    }
}
